import { useState } from "react";

export function useClipboard(timeout = 2000) {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const copy = async (text: string) => {
    console.log(text)
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setError(null);
      setTimeout(() => setCopied(false), timeout);
    } catch (err) {
      setError("Failed to copy");
      console.error("Clipboard error:", err);
    }
  };

  return { copy, copied, error };
}
